const getArgNestedLevel = (key) => {
  const arrayNestMatches = key?.match(/\[\d+\]/g);
  const arrayNestLevel = arrayNestMatches ? arrayNestMatches.length : 0;
  const argNestedLevel = key?.split('.').length - 1;
  return argNestedLevel + arrayNestLevel;
};

export default getArgNestedLevel;
